import { class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import React from "react";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableBody, TableRow, TableHead, Table, Typography, TableCell } from "@mui/material";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";

export class Components {
    constructor() {
    }
}

export function Components_$reflection() {
    return class_type("Kundeweb.Components", undefined, Components);
}

export function Components_TableHeaderCell_Z721C83C5(components_TableHeaderCell_Z721C83C5InputProps) {
    const label = components_TableHeaderCell_Z721C83C5InputProps.label;
    return MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", MuiHelpers_createElement(Typography, [["variant", "h6"], ["paragraph", false], ["children", label]])]]);
}

export function Components_Table_Z1001F0B7(components_Table_Z1001F0B7InputProps) {
    let elements_3, elements_1;
    const stickyHeader = components_Table_Z1001F0B7InputProps.stickyHeader;
    const rows = components_Table_Z1001F0B7InputProps.rows;
    const headers = components_Table_Z1001F0B7InputProps.headers;
    return MuiHelpers_createElement(Table, [["stickyHeader", defaultArg(stickyHeader, false)], (elements_3 = [MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(headers))]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(rows))]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

